// extracted by mini-css-extract-plugin
export var card = "_ah-0";
export var failedIcon = "_ah-4";
export var failedIconBadge = "_ah-3";
export var icon = "_ah-1";
export var successIcon = "_ah-2";